export class Language {

    id: number = 0;
    active: boolean = true;
    keyCode: string = '';
    default: boolean = false;
    icon: string = '';
    name: string = '';

    constructor(source: Partial<Language>) {
        Object.assign(this, source);
    }
}
